export default "__VITE_ASSET__a43d3c4b__"